<template>
  <div v-wechat-title="titleTop">
    <audio id="audioBgm" autoplay loop preload="auto">
      <source src="/img/third/ilab202104_11/bgm.mp3" type="audio/mpeg">
    </audio>
    <!-- https://res.diveboss.net/activity/third/ilab202104_11/bgm.mp3 -->
    <audio ref="audio" src="/img/third/ilab202104_11/click.mp3" />
    <div v-if="!loadImageFinish" class="backImage backImage1">

      <img src="/img/third/ilab202104_11/back_1.jpg">
    </div>
    <div v-if="!loadImageFinish" class="backImage backImage2">
      <img src="/img/third/ilab202104_11/back_2.jpg">

    </div>
    <div v-if="!loadImageFinish" class="backImage backImage3">
      <img src="/img/third/ilab202104_11/back_3.jpg">
    </div>

    <div v-if="!loadImageFinish" class="LogoRect">
      <img src="/img/third/ilab202104_11/logo.png">
    </div>
    <div v-if="nowPage==='loginPage'" class="loginPage">
      <div class="bodyRect">
        <img src="/img/third/ilab202104_11/title1.png" class="title1"><br>
        <div class="barRect">
          <div class="barBack">
            <img src="/img/third/ilab202104_11/barback.png">
          </div>
          <div class="barTop" :style="'width: '+(loginProgress*0.8)+'vw;'">
            <img src="/img/third/ilab202104_11/bartop.png">
          </div>
        </div>
        <div class="loadingLine">
          Loading....{{ loginProgress }}%
        </div>
        <img src="/img/third/ilab202104_11/title2.png" class="title2">
      </div>
    </div>
    <div v-if="nowPage==='startFollow'" class="startPage">
      <img src="/img/third/ilab202104_11/3_title2.png" class="title1"><br>
      <img src="/img/third/ilab202104_11/3_title1.png" class="title2"><br>
      <img src="/img/third/ilab202104_11/3_btn.png" class="title3" @click="onStart"><br>
    </div>
    <div v-if="nowPage==='needFollow'" class="followPage">
      <img :src="type==='iLab'?'/img/third/ilab202104_11/2_back.png':'/img/third/ilab202104_11/2_back1.png'" class="title"><br>
    </div>
    <div v-if="nowPage==='namePage'" class="namePage">
      <img src="/img/third/ilab202104_11/4_title.png" class="title1"><br>
      <div class="nameRect">  <van-field v-model="nickName" class="inputRect" placeholder="请输入昵称" input-align="center" maxlength="10" /></div>
      <img src="/img/third/ilab202104_11/4_btn.png" class="title2" @click="onStartGame"><br>
    </div>
    <div v-if="nowPage==='gamePage1'" class="gamePage">
      <img src="/img/third/ilab202104_11/5_q.png" class="question"><br>
      <van-row class="answerRect" gutter="10">
        <van-col span="12">
          <img :src="question1==='A'?'/img/third/ilab202104_11/5_btn_0_.png':'/img/third/ilab202104_11/5_btn_0.png'" class="rect" @click="onQuestion1('A')">
          <br>
          <img :src="question1==='C'?'/img/third/ilab202104_11/5_btn_2_.png':'/img/third/ilab202104_11/5_btn_2.png'" class="rect" @click="onQuestion1('C')">
        </van-col>
        <van-col span="12">
          <img :src="question1==='B'?'/img/third/ilab202104_11/5_btn_1_.png':'/img/third/ilab202104_11/5_btn_1.png'" class="rect" @click="onQuestion1('B')">
          <br>
          <img :src="question1==='D'?'/img/third/ilab202104_11/5_btn_3_.png':'/img/third/ilab202104_11/5_btn_3.png'" class="rect" @click="onQuestion1('D')">
        </van-col>
      </van-row>
    </div>
    <div v-if="nowPage==='gamePage2'" class="gamePage">
      <img src="/img/third/ilab202104_11/6_q.png" class="question"><br>
      <div class="answerRect">
        <img :src="question2==='A'?'/img/third/ilab202104_11/6_btn_0_.png':'/img/third/ilab202104_11/6_btn_0.png'" class="rect" @click="onQuestion2('A')"><br>
        <img :src="question2==='B'?'/img/third/ilab202104_11/6_btn_1_.png':'/img/third/ilab202104_11/6_btn_1.png'" class="rect" @click="onQuestion2('B')"><br>
        <img :src="question2==='C'?'/img/third/ilab202104_11/6_btn_2_.png':'/img/third/ilab202104_11/6_btn_2.png'" class="rect" @click="onQuestion2('C')"><br>
        <img :src="question2==='D'?'/img/third/ilab202104_11/6_btn_3_.png':'/img/third/ilab202104_11/6_btn_3.png'" class="rect" @click="onQuestion2('D')"><br>
      </div>
    </div>
    <div v-if="nowPage==='gamePage3'" class="gamePage">
      <img src="/img/third/ilab202104_11/7_q.png" class="question"><br>
      <div class="answerRect">
        <img :src="question3==='A'?'/img/third/ilab202104_11/7_btn_0_.png':'/img/third/ilab202104_11/7_btn_0.png'" class="rect" @click="onQuestion3('A')"><br>
        <img :src="question3==='B'?'/img/third/ilab202104_11/7_btn_1_.png':'/img/third/ilab202104_11/7_btn_1.png'" class="rect" @click="onQuestion3('B')"><br>
        <img :src="question3==='C'?'/img/third/ilab202104_11/7_btn_2_.png':'/img/third/ilab202104_11/7_btn_2.png'" class="rect" @click="onQuestion3('C')"><br>
        <img :src="question3==='D'?'/img/third/ilab202104_11/7_btn_3_.png':'/img/third/ilab202104_11/7_btn_3.png'" class="rect" @click="onQuestion3('D')"><br>
        <img :src="question3==='E'?'/img/third/ilab202104_11/7_btn_4_.png':'/img/third/ilab202104_11/7_btn_4.png'" class="rect" @click="onQuestion3('E')"><br>
      </div>
    </div>
    <div v-if="nowPage==='gamePage4'" class="gamePage">
      <img src="/img/third/ilab202104_11/8_q_.png" class="question"><br>
      <div class="answerRect">
        <img :src="question4.indexOf('A')>=0?'/img/third/ilab202104_11/8_btn__0_.png':'/img/third/ilab202104_11/8_btn__0.png'" class="rect" @click="onQuestion4('A')"><br>
        <img :src="question4.indexOf('B')>=0?'/img/third/ilab202104_11/8_btn__1_.png':'/img/third/ilab202104_11/8_btn__1.png'" class="rect" @click="onQuestion4('B')"><br>
        <img :src="question4.indexOf('C')>=0?'/img/third/ilab202104_11/8_btn__2_.png':'/img/third/ilab202104_11/8_btn__2.png'" class="rect" @click="onQuestion4('C')"><br>
        <img :src="question4.indexOf('D')>=0?'/img/third/ilab202104_11/8_btn__3_.png':'/img/third/ilab202104_11/8_btn__3.png'" class="rect" @click="onQuestion4('D')"><br>
        <img :src="question4.indexOf('E')>=0?'/img/third/ilab202104_11/8_btn__4_.png':'/img/third/ilab202104_11/8_btn__4.png'" class="rect" @click="onQuestion4('E')"><br>
        <div class="nextButton">
          <img src="/img/third/ilab202104_11/8_btn.png" @click="onQuestion4Finish()"><br>
        </div>
      </div>
    </div>
    <div v-if="nowPage==='createPage'" class="loginPage finishPage">
      <div v-show="loadImageFinish" class="imgFinish">
        <van-image width="100%" :src="imgUrl" @load="onImgLoadFinish" />
        <div class="buttonRect" @click="showShare=true; $refs.audio.play();" />
      </div>
      <div v-show="!loadImageFinish" class="bodyRect">
        <img src="/img/third/ilab202104_11/9_title.png" class="title1"><br>
        <div class="barRect">
          <div class="barBack">
            <img src="/img/third/ilab202104_11/barback.png">
          </div>
          <div class="barTop" :style="'width: '+(createProgress*0.8)+'vw;'">
            <img src="/img/third/ilab202104_11/bartop.png">
          </div>
        </div>
        <div class="loadingLine">
          Loading....{{ createProgress }}%
        </div>
      </div>
    </div>
    <!-- <div v-if="nowPage==='finish'" class="finishPage">
      <img src="/img/third/ilab202104_11/10_title.png" class="title"><br>
      <img :src="'/img/third/ilab202104_11/10_'+answer+'.png'" class="body"><br>
      <div class="button">
        <van-row gutter="20">
          <van-col span="12"><img src="/img/third/ilab202104_11/10_btn_l.png" class="btn" @click="onShowAnswerImage"></van-col>
          <van-col span="12"><img src="/img/third/ilab202104_11/10_btn_r.png" class="btn" @click="showShare=true; $refs.audio.play();"></van-col>
        </van-row>
      </div>
    </div> -->
    <!-- <div v-if="nowPage==='img'" class="finishImage">

    </div> -->
    <wxShare v-model="showShare" share-title="点击这里分享" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Image } from 'vant'
import { getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
import wxShare from '@/components/wxShare'
import { GetServiceUrlBase } from '@/utils/request'

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Image.name]: Image,
    wxShare
  },
  data() {
    return {
      titleTop: '领取你的“蓝朋友”',
      loginProgress: 0,
      createProgress: 0,
      nowPage: 'loginPage',
      userInfo: {
        thirdUserId: undefined,
        isFollow: false
      },
      nickName: '',
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: undefined,
      shareIcon: '',
      question1: '',
      question2: '',
      question3: '',
      question4: [],
      answer: '',
      imgLoading: true,
      imgUrl: undefined,
      loadImageFinish: false,
      type: 'iLab'
    }
  },

  created() {
    this.init()

    document.addEventListener('DOMContentLoaded', function() {
      function audioAutoPlay() {
        var audio = document.getElementById('audioBgm')
        audio.play()
        document.addEventListener('WeixinJSBridgeReady', function() {
          audio.play()
        }, false)
      }
      audioAutoPlay()
    })
    // --创建触摸监听，当浏览器打开页面时，触摸屏幕触发事件，进行音频播放
    document.addEventListener('touchstart', function() {
      function audioAutoPlay() {
        var audio = document.getElementById('audioBgm')
        audio.play()
      }
      audioAutoPlay()
    })
    document.addEventListener('WeixinJSBridgeReady', function() {
      function audioAutoPlay() {
        var audio = document.getElementById('audioBgm')
        audio.play()
      }
      audioAutoPlay()
    })
  },
  methods: {
    GetServiceUrlBase,
    getUrlKey,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init() {
      setTimeout(() => {
        this.initShare()
        this.nowPage = 'startFollow'
      }, 1)
      // var types = getUrlKey('types')
      // if (types) {
      //   this.type = 'iLabNew'
      // }
      // var thirdUserId = getUrlKey('thirdUserId')
      // var code = getUrlKey('code')
      // if (!thirdUserId && !code) {
      //   // 登录
      //   this.getWxLoginUrl((url) => {
      //     console.log('跳转页面去登录', url)
      //     window.location.href = url
      //   })
      //   return
      // }

      // var my = this
      // var loginPro = setInterval(() => {
      //   my.loginProgress += 1
      //   if (my.loginProgress > 99) {
      //     my.loginProgress = 99
      //     clearInterval(loginPro)
      //   }
      // }, 10)

      // if (thirdUserId) {
      //   this.loginAndRegThirdUserInfo(null, thirdUserId, () => {
      //     this.loginThirdFinish(my)
      //     this.initShare()
      //   })
      // } else {
      //   // 读取注册用户信息
      //   this.loginAndRegThirdUserInfo(code, null, () => {
      //     this.loginThirdFinish(my)
      //     this.initShare()
      //   })
      // }
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    getWxLoginUrl(callback) {
      request({
        url: '/ThirdActivitie/wechatLogin',
        method: 'post',
        data: {
          url: 'https://m.diveboss.net/ilab/202104',
          type: this.type
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        var url = Response.data
        if (callback) {
          callback(url)
        }
      })
    },
    loginThirdFinish(my) {
      if (my.userInfo.isFollow) {
        my.$router.push('/ilab/202104?thirdUserId=' + my.userInfo.thirdUserId)
      }
      if (my.userInfo.nickName) {
        my.nickName = my.userInfo.nickName
      }
      if (my.loginProgress > 95) {
        my.nowPage = my.userInfo.isFollow ? 'startFollow' : 'needFollow'// startFollow  needFollow
      } else {
        setTimeout(() => {
          my.nowPage = my.userInfo.isFollow ? 'startFollow' : 'needFollow'
        }, 1000)
      }
    },
    loginAndRegThirdUserInfo(code, thirdUserId, callback) {
      request({
        url: '/ThirdActivitie/GetAndRegThirdActiviteUser',
        method: 'post',
        data: {
          code: code,
          thirdUserId: thirdUserId,
          type: this.type,
          keyCode: 'iLab202104'
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.userInfo = Response.data
        if (callback) {
          callback()
        }
      })
    },
    initShare() {
      this.shareTitle = '领取你的“蓝朋友”'
      this.shareAbout = '不用等国家分配，现在！立马！安排！'
      this.shareTimeline = '领取你的“蓝朋友”'
      this.shareIcon = GetSelfUrl() + 'img/third/ilab202104_11/icon.jpg'
      this.shareUrl = undefined
      this.shareUrl = 'https://m.diveboss.net/ilab/2021041?t=' + Date.now()
      setTimeout(() => {
        this.shareUrl = undefined
        this.shareUrl = 'https://m.diveboss.net/ilab/2021041?t=' + Date.now()
      }, 2000)
    },
    onStart() {
      this.nowPage = 'namePage'
      this.$refs.audio.play()
    },
    onStartGame() {
      this.nowPage = 'gamePage1'
      this.$refs.audio.play()
    },
    onQuestion1(select) {
      this.question1 = select
      this.$refs.audio.play()
      setTimeout(() => {
        this.nowPage = 'gamePage2'
      }, 300)
    },
    onQuestion2(select) {
      this.question2 = select
      this.$refs.audio.play()
      setTimeout(() => {
        this.nowPage = 'gamePage3'
      }, 300)
    },
    onQuestion3(select) {
      this.question3 = select
      this.$refs.audio.play()
      setTimeout(() => {
        this.nowPage = 'gamePage4'
      }, 300)
    },
    onQuestion4(select) {
      this.$refs.audio.play()
      if (this.question4.indexOf(select) >= 0) {
        this.question4.splice(this.question4.indexOf(select), 1)
      } else {
        this.question4.push(select)
      }
    },
    onQuestion4Finish() {
      this.loadImageFinish = false
      this.$refs.audio.play()
      this.answer = this.getFinishCode()
      var url = GetServiceUrlBase() + '/userAPI/ThirdActivitie/GetiLab2021041Image?nickName=' + this.nickName +
        '&id=' + this.answer
      this.imgUrl = url
      setTimeout(() => {
        this.nowPage = 'createPage'
        this.createProgress = 0
        var my = this

        var createPro = setInterval(() => {
          my.createProgress += 1
          if (my.createProgress > 99) {
            my.createProgress = 99
            clearInterval(createPro)
            this.loadImageFinish = true
          }
        }, 20)
      }, 300)
    },
    onShowAnswerImage() {
      this.$refs.audio.play()
    },
    onImgLoadFinish() {
      this.loadImageFinish = true
    },
    getFinishCode() {
      var hm = 0
      var sy = 0
      var jy = 0
      var qe = 0
      var ht = 0
      switch (this.question1) {
        case 'A':hm++; ht++; break
        case 'B':jy++; hm++; break
        case 'C':sy++; break
        case 'D':qe++; ht++; break
      }
      switch (this.question2) {
        case 'A':hm++; ht++; break
        case 'B':ht++; qe++; break
        case 'C':sy++; break
        case 'D':jy++; break
      }
      switch (this.question3) {
        case 'A':hm++; break
        case 'B':ht++; sy++; break
        case 'C':jy++; qe++; break
        case 'D':hm++; qe++; break
        case 'E':jy++; hm++; break
      }
      for (var i = 0; i < this.question4.length; i++) {
        switch (this.question4[i]) {
          case 'A':jy++; break
          case 'B':hm++; break
          case 'C':sy++; break
          case 'D':qe++; break
          case 'E':ht++; break
        }
      }
      if (hm >= sy && hm >= jy && hm >= qe && hm >= ht) {
        return '0'
      }
      if (sy >= hm && sy >= jy && sy >= qe && sy >= ht) {
        return '1'
      }
      if (jy >= hm && jy >= sy && jy >= qe && jy >= ht) {
        return '2'
      }
      if (qe >= hm && qe >= sy && qe >= jy && qe >= ht) {
        return '3'
      }
      return '4'
    }
  }
}
</script>
<style scoped>
.backImage{
    position: absolute;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
}
.backImage img{
    height: 100%;
}

.backImage1{
  background-color: #024190;
}
.backImage2{
  animation-name: light2;
  animation-duration: 2.7s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
.backImage3 {
  animation-name: light;
  animation-duration: 1.8s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes light{
        from{
            opacity: 1;
        }
        to{
            opacity: 0.1;
        }
    }
    @keyframes light2{
        from{
            opacity: 0.1;
        }
        to{
            opacity: 1;
        }
    }
.LogoRect{
    position:absolute;
    width: 26vw;
    left: 50%;
    bottom: 5vh;
    margin-left: -13vw;
}
.LogoRect img{
    width: 100%;
}

.loginPage{
    position: absolute;
    left: 0;
    top:0;
    width: 100vw;
    height: 100vh;
}
.loginPage img{
    width: 100%;
}
.loginPage .title1{
    width: 80vw;
    padding: 0 10vw;
    margin-top: 30vh;
}
.loginPage .barRect{
    width: 80vw;
    height: 10vh;
    margin-left: 10vw;
    margin-top: 5vw;
    position: relative;
    overflow: hidden;
}
.loginPage .barRect .barBack{
    position: absolute;
    left: 0;
    top: 0;
    width: 80vw;
    z-index: 0;

}
.loginPage .barRect .barTop{
    position: absolute;
    z-index: 1;
    top: 0;
    width: 0;
    left:0;
    height: 11.34vw;
    overflow: hidden;
}
.loginPage .barRect .barTop img{
  height: 100%;
}
.loginPage  .loadingLine{
    color: #fff;
    text-align: center;
    font-size: 1.5em;
}

.loginPage .title2{
    width: 40vw;
    padding: 0 30vw;
    margin-top: 1vh;
}

.startPage{
    position: absolute;
    left: 0;
    top:0;
    width: 100vw;
    height: 100vh;
}
.startPage img{
    width: 100%;
}
.startPage .title1{
    width: 70vw;
    padding: 0 15vw;
    margin-top: 25vh;
}
.startPage .title2{
    width: 80vw;
    padding: 0 10vw;
    margin-top: 5vh;
}
.startPage .title3{
    width: 40vw;
    padding: 0 30vw;
    margin-top: 2vh;
}
.namePage{
    position: absolute;
    left: 0;
    top:0;
    width: 100vw;
    height: 100vh;
}
.namePage .title1{
    width: 60vw;
    padding: 0 20vw;
    margin-top: 30vh;
}
.namePage .nameRect{
    width: 60vw;
    padding: 0 20vw;
    margin-top: 1vh;

}
.namePage .nameRect .inputRect{
    border-radius: 0.4em;
    font-weight: 700;
}
.namePage .title2{
    width: 40vw;
    padding: 0 30vw;
    margin-top: 5vh;
}
.gamePage{
  position: absolute;
  left: 0;
  top:0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.gamePage .question{
  width: 80vw;
  padding: 0 10vw;
  margin-top: 10vh;
}
.gamePage img{
    width: 100%;
}
.gamePage .answerRect{
    padding: 0 10vw;
    margin-top: 5vh;
}
.gamePage .answerRect .rect{
    padding: 5px 0;
}
.gamePage .nextButton{
  text-align: center;
}
.gamePage .nextButton img{
  width: 60%;
}
.finishPage .imgFinish{
  position: relative;
}
.finishPage .imgFinish .buttonRect{
  color: #024190;
  width: 50vw;
  height: 20vw;
  position: absolute;
  bottom: 35vw;
  left: 25vw;
  z-index: 10;
}
.followPage{
  position: absolute;
  left: 0;
  top:0;
  width: 100vw;
  height: 100vh;
}
.followPage img{
  width: 100%;
}
.followPage .title{
  width: 80vw;
  padding: 0 10vw;
  margin-top: 20vh;
}
.finishImage{
  position: absolute;
  left: 0;
  top:0;
  width: 100vw;
  height: 100vh;
}
.finishImage img{
  width: 100%;
}
</style>
